module.exports = __webpack_public_path__ + "static/sponsorship_img-07-b@2x-a9cafc908e0141c0e5764dc953747115.jpg";